var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"copy",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.copy.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }